import { Producer } from './producerClass';

export enum ViewType {
  CLASSIC = 'CLASSIC',
  COVER = 'COVER',
  SPLIT = 'SPLIT',
  PIP = 'PIP',
  CINEMA = 'CINEMA',
  SIDEBYSIDE = 'SIDEBYSIDE'
}

export enum ToolsType {
  NONE = 'NONE',
  GRAPHICS = 'GRAPHICS',
  CHAT = 'CHAT',
  POLL = 'POLL',
  QA = 'Q&A',
  HOSTCHAT = 'HOST CHAT',
  PEOPLE = 'PEOPLE',
  SETTINGS = 'SETTINGS',
}

export enum GraphicsType {
  LOGOS = 'LOGOS',
  BRAND_SETTINGS = 'BRAND SETTINGS',
  LOWER_THIRDS = 'LOWER THIRDS',
  TICKERS = 'TICKERS',
  NAME_TAGS = 'NAME TAGS',
  IMAGES = 'IMAGES',
  VIDEOS = 'VIDEOS',
  BACKGROUNDS = 'BACKGROUNDS',
}

export class Layout {
  view: ViewType;
  selectedTool: string;
  liveControlsVisible: boolean;
  selectedMenu: {
    isMenu: boolean;
    producer: Producer|null;
  };
  outputStreams: any;
  liveStreamRunning: boolean;
  contentSharing: boolean;

  constructor() {
    this.view = ViewType.CLASSIC;
    this.liveControlsVisible = true;
    this.selectedTool = ToolsType.GRAPHICS;
    this.selectedMenu = { isMenu: false, producer: null};
    this.outputStreams = { studio: true, youtube: false, facebook: false};
    this.liveStreamRunning = false;
    this.contentSharing = false;
  }
}

